import BaseComponent from "../../../engines/components/BaseComponent";

const {ccclass, property} = cc._decorator;

@ccclass
export default class HelpWifeLayer1Tools extends BaseComponent {

    @property
    tag: number = 0;

}
